/**
 * Renders an INR amount stored in paise (integer × 100, per spec §16).
 *
 * Variants:
 *  - "default"  inline body figure: ₹99,900
 *  - "data"     mono figure for tables, right-aligned tabular nums
 */

interface MoneyProps {
  paise: number | bigint
  variant?: 'default' | 'data'
  className?: string
  showZeroPaise?: boolean
}

const formatter = new Intl.NumberFormat('en-IN', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

export function Money({
  paise,
  variant = 'default',
  className = '',
  showZeroPaise,
}: MoneyProps) {
  const total = typeof paise === 'bigint' ? Number(paise) : paise
  const rupees = Math.trunc(total / 100)
  const cents = Math.abs(total) % 100
  const showCents = cents > 0 || showZeroPaise

  if (variant === 'data') {
    return (
      <span className={`font-mono tabular-nums text-fg ${className}`}>
        ₹{formatter.format(rupees)}
        {showCents ? `.${cents.toString().padStart(2, '0')}` : ''}
      </span>
    )
  }

  return (
    <span className={`tabular-nums ${className}`}>
      ₹{formatter.format(rupees)}
      {showCents ? (
        <span className="text-fg-subtle">.{cents.toString().padStart(2, '0')}</span>
      ) : null}
    </span>
  )
}
